<template>
    <div class="nav">
        <ul>
            <li v-if="!hasLimitedAccess" class="home">
                <router-link to="/">
                    <div class="icon">               
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                      <path class="fill-dark-grey" d="M100,301.585a2,2,0,0,0,2.828,2.828,38.259,38.259,0,0,0,1.562-4.39,38.985,38.985,0,0,0-4.39,1.56v0Zm9.922-4.016c-1.772,5.97-2.782,8.78-3.674,9.672A6,6,0,1,1,97.53,299c0.077-.081.155-0.159,0.236-0.236,0.89-.892,3.7-1.9,9.672-3.676a2,2,0,0,1,2.488,2.488Zm7.954,7.43H116a2,2,0,0,1,0-4h1.876A16.009,16.009,0,0,0,104,287.123V289a2,2,0,0,1-4,0v-1.876A16.009,16.009,0,0,0,86.124,301H88a2,2,0,0,1,0,4H84a1.994,1.994,0,0,1-2-1.988V303a19.992,19.992,0,1,1,2.386,9.48,2,2,0,1,1,3.52-1.9A16,16,0,0,0,117.876,305Z" transform="translate(-82 -283)"/>
                    </svg>

                    </div>
                    {{ $t('sidebar.nav.dashboard') }}
                </router-link>
            </li>
            <li v-if="!hasLimitedAccess">
                <router-link to="/properties">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21.984" height="20" viewBox="0 0 43.969 40">
                          <path class="fill-dark-grey" d="M102.016,406.991a4,4,0,1,0-4-4A4,4,0,0,0,102.016,406.991Zm-2,3.751a8.027,8.027,0,0,1-4.993-11.621,7.8,7.8,0,0,1,4.894-3.87,8.012,8.012,0,1,1,4.1,15.491V415H114V398.984a2,2,0,0,1,2-2h0.788l-14.778-13.321L87.235,396.983h0.787a2,2,0,0,1,2,2V415h4a2,2,0,0,1,0,4h-6a2,2,0,0,1-2-2V400.986h-4a2,2,0,0,1-1.337-3.489l19.986-18.014a2,2,0,0,1,2.674,0L123.335,397.5A2,2,0,0,1,122,400.986h-4V417a2,2,0,0,1-2,2h-13.99a2,2,0,0,1-2-2v-6.256Z" transform="translate(-80.031 -379)"/>
                        </svg>
                    </div>
                    {{ $t('sidebar.nav.properties') }}
                </router-link>
            </li>
            <li v-if="!hasLimitedAccess">
                <router-link to="/screenings">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.016" height="19.969" viewBox="0 0 32.031 39.938">
                          <path class="fill-dark-grey" d="M114.584,492.6L102,505.161l-4.586-4.579a2,2,0,0,0-2.828,2.824l6,5.991a2,2,0,0,0,2.828,0L114,498.827v10.516a5.989,5.989,0,0,1-3.023,5.2L102,519.663l-8.976-5.122a5.991,5.991,0,0,1-3.024-5.2v-19.8a47.968,47.968,0,0,1,25.45.393,2,2,0,1,0,1.1-3.842,52.1,52.1,0,0,0-29.1,0A2,2,0,0,0,86,488.016v21.327a9.981,9.981,0,0,0,5.038,8.664l9.97,5.691a2,2,0,0,0,1.984,0l9.968-5.691a9.98,9.98,0,0,0,5.04-8.666V494.007A2,2,0,0,0,114.584,492.6Z" transform="translate(-86 -484.031)"/>
                        </svg>
                    </div>
                    {{ $t('sidebar.nav.screenings') }}
                </router-link>
            </li>
            <li>
                <router-link to="/contracts">
                    <div class="icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 32 40">
                          <path id="Contracts" class="fill-dark-grey" d="M96,612a2,2,0,0,1,0-4h8a2,2,0,1,1,0,4H96Zm0-16a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4H96Zm0,8a2,2,0,0,1,0-4h12a2,2,0,0,1,0,4H96Zm-6-18v34a2,2,0,0,1-4,0V584a2,2,0,0,1,2-2h20a2,2,0,0,1,1.415.586l8,8A2,2,0,0,1,118,592v28a2,2,0,0,1-2,2H96a2,2,0,0,1,0-4h18V592.827L107.174,586H90Z" transform="translate(-86 -582)"/>
                        </svg>

                    </div>
                    {{ $t('sidebar.nav.contracts') }}
                </router-link>
            </li>
            <!-- <li>
                <router-link to="/companies">
                    <div class="icon">
                        <simple-svg
                            :filepath="'images/SVG/Sidebar/Contracts.svg'"
                            :width="'16px'"
                            :height="'20px'"
                            
                        />
                    </div>
                    Companies
                </router-link>
            </li> -->
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'hasLimitedAccess',
                'subscriptionIsUnlimited'
            ])
        },
        name: "LandlordNavigation"
    }
</script>

<style scoped>

</style>